import { FC, useCallback, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { Extension, Settings } from '@clds/icon';
import { UserRole } from '@cld/application-wrapper-common';
import { PrimaryMenuItem } from '../../components/PrimaryMenu';
import { HelpDropdownMenu } from '../HelpDropdownMenu/HelpDropdownMenu';
import { MENU_ITEM_ICON_SIZE } from '../../ApplicationWrapper.const';
import { UserDropdownMenu } from '../UserDropdownMenu/UserDropdownMenu';
import { messages } from '../../i18n';
import { useApplicationWrapperContext } from '../../context/applicationWrapper/ApplicationWrapper.context';
import { useCustomerIdContext } from '../../context';
import { BottomPrimaryMenuItemsProps } from './BottomPrimaryMenuItems.types';
import { getMarketplaceHref, getSettingsHref } from './utils';
import { useAccountInfoData } from '../../components/UpgradePopupModal/usePopupModal';
import { useUserData } from '../../context';

export const BottomPrimaryMenuItems: FC<BottomPrimaryMenuItemsProps> = ({ onSettingsClick }) => {
  const { formatMessage } = useIntl();
  const { selectedAppId } = useApplicationWrapperContext();
  const { currentCustomer } = useCustomerIdContext();
  const accountInfoData = useAccountInfoData();
  const { userData } = useUserData();
  const [settingsHref, setSettingsHref] = useState(getSettingsHref(currentCustomer));
  const [marketplaceHref, setMarketplaceHref] = useState(getMarketplaceHref(currentCustomer));

  const shouldDisplayMarketplace = useMemo(
    () => accountInfoData?.iseNewBilling && (userData?.role === UserRole.MasterAdmin || userData?.role === UserRole.Billing),
    [accountInfoData?.iseNewBilling, userData?.role]
  );

  // FIXME: why is this needed??
  const onSettingsMouseEnter = useCallback(() => {
    setSettingsHref(getSettingsHref(currentCustomer));
  }, [currentCustomer]);

  // FIXME: why is this needed??
  const onMarketplaceMouseEnter = useCallback(() => {
    setMarketplaceHref(getMarketplaceHref(currentCustomer));
  }, [currentCustomer]);

  return (
    <>
      {shouldDisplayMarketplace && (
        <PrimaryMenuItem
          data-test-specififier="marketplace button"
          type="link"
          analyticsMessage="marketplace"
          analyticsAction="navigate"
          selected={window.location.pathname.includes('/marketplace')}
          tooltipTitle={formatMessage(messages.marketplaceMenuTooltip)}
          href={marketplaceHref}
          onMouseEnter={onMarketplaceMouseEnter}
          rel="noopener noreferrer"
        >
          <Extension size={MENU_ITEM_ICON_SIZE} />
        </PrimaryMenuItem>
      )}

      <HelpDropdownMenu />

      <PrimaryMenuItem
        data-test-specififier="settings button"
        type="link"
        analyticsMessage="settings"
        analyticsAction="navigate"
        // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
        selected={selectedAppId === 'settings'}
        tooltipTitle={formatMessage(messages.settingsMenuTooltip)}
        href={settingsHref}
        onMouseEnter={onSettingsMouseEnter}
        rel="noopener noreferrer"
        onClick={onSettingsClick}
      >
        <Settings size={MENU_ITEM_ICON_SIZE} />
      </PrimaryMenuItem>
      <UserDropdownMenu />
    </>
  );
};
